function topic_cctv(){
	// var news_data = {
	// 	...raw_data["新聞局公共監測CCTV"],
	// 	features: raw_data["新聞局公共監測CCTV"].features.filter(el => el.properties.stnAddress !== '雙泰產業道路')
	// }
	// var district_office_data = {
	// 	...raw_data["新聞局公共監測CCTV"],
	// 	features: raw_data["新聞局公共監測CCTV"].features.filter(el => el.properties.stnAddress == '雙泰產業道路')
	// }

	var cctv_data = [
		// {data: news_data, table_id: "table_1", name: "新聞局CCTV清單", column_name: ["stnId", "stnAddress", "stnAddress", "cctv_url"], url_type: "iframe"},
		{data: raw_data["新聞局公共監測CCTV"], table_id: "table_1", name: "新聞局CCTV清單", column_name: ["stnId", "stnAddress", "stnAddress", "cctv_url"], url_type: "iframe"},
		{data: raw_data["交通局CCTV"], table_id: "table_2", name: "交通局CCTV清單", column_name: ["station_id", "location_name", "location_name", "cctv_url"], url_type: "iframe"},
		{data: raw_data["公路局CCTV"], table_id: "table_3", name: "公路局CCTV清單", column_name: ["station_id", "station_name",	"station_name", "cctv_url"], url_type: "image"},
		// {data: raw_data["水利局河川CCTV"], table_id: "table_4", name: "水利局河川CCTV清單", column_name: ["name", "name", "name", "cctv_url"], url_type: "iframe"},
		{data: raw_data["水利署CCTV"], table_id: "table_4", name: "水利署CCTV清單", column_name: ["station_name", "address", "station_name", "cctv_url"], url_type: "image"},
		{data: raw_data["水保署CCTV"], table_id: "table_5", name: "水保署CCTV清單", column_name: ["station_name", "location_name", "station_name", "cctv_url"], url_type: "iframe"},
		{data: raw_data["高公局CCTV"], table_id: "table_6", name: "高公局CCTV清單", column_name: ["station_id", "location_name", "location_name", "cctv_url"], url_type: "image"},
		{data: raw_data["水利局高灘地CCTV"], table_id: "table_7", name: "水利局高灘地CCTV清單", column_name: ["cctv_no", "location", "location", "cctv_url"], url_type: "iframe"},
		// {data: raw_data["道路管理中心CCTV"], table_id: "table_8", name: "道路管理中心CCTV清單", column_name: ["name", "name", "name", "cctv_url"], url_type: "iframe"},
		{data: raw_data["車行地下道CCTV"], table_id: "table_9", name: "車行地下道CCTV清單", column_name: ["name", "name", "name", "cctv1"], url_type: "iframe"},
		// {data: district_office_data, table_id: "table_10", name: "區公所CCTV清單", column_name: ["stnId", "stnAddress", "stnAddress", "cctv_url"], url_type: "iframe"}
	],
	html_string = "";

	var display_css = "d-none", icon_down_up = "fas fa-angle-up float-right mt-1";
	cctv_data.forEach(function(element){
		html_string +=
			'<div>'+
				'<div class="slider-card-head p-2">'+
					'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>'+ element.name + '<i class="' + icon_down_up +'"></i></h5>' +
		        '</div>'+
		        '<div class="' + display_css +' slider-card-content">'+
		            '<table class="cctv_control_table mb-2 table table-sm" id="' + element.table_id + '" width="100%" height="100%">' +
		                '<thead class="thead-dark">' +
		                    '<tr>' +
								`<th style="width:16px" class=${element.name == '交通局CCTV清單' ? "d-none":""}>選</th>`+
		                        '<th class="w-50">站名</th>' +
		                        '<th class="w-50">地址</th>' +
		                    '</tr>' +
		                '</thead>' +
		                '<tbody>' +
		                '</tbody>' +
		            '</table>' +
		        '</div>' +
	        '</div>';
	});

	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("CCTV")
		}, false) +
		'<div class="row">' +
			'<div class="col-12 mb-1" id="all-cctv-table-div">' +
				'<div>'+
					'<div class="slider-card-head p-2">'+
						'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>建議查看清單(位重大災情點20m內)<i class="fas fa-angle-up float-right mt-1"></i></h5>' +
			        '</div>'+
			        '<div class="slider-card-content d-none">'+
						'<div class="input-group mt-2">'+
						  	'<div class="input-group-prepend">'+
						    	'<label class="input-group-text">選擇鄰近距離</label>'+
						  	'</div>'+
						  	'<select class="custom-select" id="near_cctv_distance">'+
						  		'<option value="20">20m(預設)</option>'+
						  		'<option value="50">50m</option>'+
						  		'<option value="100">100m</option>'+
						  	'</select>'+
						'</div>'+
			            '<button type="button" class="btn btn-primary btn-sm btn-block mt-2" id="cctv_advise_trig"><i class="fas fa-table mr-1"></i>運算產生報表</button>'+
			            '<div class="text-center mt-2" id="cctv_advise_table">-暫無結果-</div>'+
			        '</div>' +
		        '</div>'+
				html_string +
			'</div>'+
		'</div>'
	);

	cctv_data.forEach(function(element, index){
		// var id_name = '#table_' + (index+1) +' tbody';
		var id_name = `#${element.table_id} tbody`;

		element.data.features.forEach(function(each_features){
			var this_properties = each_features.properties;
	        var input_check = $(
	            `<tr class="p-cursor">
					<td class=${element.name == '交通局CCTV清單' ? "d-none":"td_cctv_checkbox"}>
						<input type="checkbox" class="cctv_checkbox"
							${cctv_render_list.map(el => el.station_name.split('-')[1])
								.includes(this_properties[element.column_name[2]]) ? "checked" : null}
							cctv_class="${element.name.split('CCTV')[0]}"
							station_name="${this_properties[element.column_name[2]]}"
							url_string="${this_properties[element.column_name[3]]}"
							url_type="${element.url_type}">
					</td>
	                <td>${this_properties[element.column_name[0]]}</td>
	                <td>${this_properties[element.column_name[1]]}</td>
	            </tr>`
	        );
	        input_check.click(function(e){
				if (e.target.className == "td_cctv_checkbox" || e.target.className == "cctv_checkbox") return;
	            map.setView([each_features.geometry.coordinates[1], each_features.geometry.coordinates[0]], 18);
	        });
	       	$(id_name).append(input_check);
		});
	});
	$('.cctv_checkbox').change(function(){
		if (this.checked) {
			if (cctv_render_list.length < 9) {
				console.log($(this).parent().find('span '))
				cctv_render_list.push({
					station_name: $(this).attr('cctv_class') + '-' + $(this).attr('station_name'),
					url_string: $(this).attr('url_string'),
					url_type: $(this).attr('url_type')
				});
				cctv_render_list.forEach((el, index) => {
					cctv_group_append(el.station_name, el.url_string, el.url_type, index+1)
				})
				for (let i = 0; i < 9; i++) {
					(i+1) > cctv_render_list.length
						? $("#cctv-order-" + (i+1) + ' button').addClass('d-none')
						: $("#cctv-order-" + (i+1) + ' button').removeClass('d-none')
				}
				localStorage.setItem('cctv_render_list', JSON.stringify(cctv_render_list))
			} else {
				alert('CCTV群組容量已滿，請先關閉部分CCTV。')
			}
		} else {
			let target_index =  cctv_render_list.findIndex(el => el.station_name.split('-')[1] == this.station_name)
			cctv_render_list.splice(target_index, 1)
			// remove all
			for (let i = 0; i < 9; i++) {
				$("#cctv-order-" + (i+1) + ' h6').text(`CCTV ${i+1}`)
				$("#cctv-order-" + (i+1) + ' button').addClass('d-none')
				$("#cctv-container-" + (i+1)).html(`<h4>CCTV ${i+1}</h4>`)
			}
			// add the remained cctv
			cctv_render_list.forEach((el, index) => {
				cctv_group_append(el.station_name, el.url_string, el.url_type, index+1)
				$("#cctv-order-" + (index+1) + ' button').removeClass('d-none')
			})
			localStorage.setItem('cctv_render_list', JSON.stringify(cctv_render_list))
		}
	})

    $('.cctv_control_table').DataTable({
        "order": [[ 1, "desc" ]],
        "searching": true
    });

    $("#cctv_advise_trig").click(function(){
		if (emis_event_select) {
			loader_asynchronous(function(){
				backgroud_layer_control("重大災情");
				var cctv_distance_setting = parseInt($("#near_cctv_distance").val()),
					event_id_list = {};
				$("#cctv_advise_table").html(
					'<table class="mb-2 table table-sm" width="100%" height="100%">' +
						'<thead class="thead-dark">' +
							'<tr>' +
								'<th>區別</th>' +
								'<th>嚴重性</th>' +
								'<th>處理狀態</th>' +
								'<th>災情類型</th>' +
							'</tr>' +
						'</thead>' +
						'<tbody>' +
						'</tbody>' +
					'</table>'
				);

				var police_cctv_html_string = "", police_cctv_within;
				raw_data["event"][1].features.forEach(function(feature, index){
					if ((raw_data["event"][1].features.length-1) == index) {
						police_cctv_html_string += "(" + feature.geometry.coordinates[0] + "%20" + feature.geometry.coordinates[1] + ")";
					} else {
						police_cctv_html_string += "(" + feature.geometry.coordinates[0] + "%20" + feature.geometry.coordinates[1] + "),%20";
					};
				});
				if (police_cctv_html_string != "") {
					police_cctv_within = ajax_call(publicPath + "/cloud/geoserver/edp2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=edp2%3Apolice_cctv&maxFeatures=50&cql_filter=DWITHIN(geom,MULTIPOINT(" + police_cctv_html_string + ")," + cctv_distance_setting + ",meters)&outputFormat=application%2Fjson");
				} else {
					police_cctv_within = {"type": "FeatureCollection", "features": []};
				}
				cctv_data.push({
					data: police_cctv_within, table_id: "table_10", name: "警察局CCTV清單", column_name: ["id", "name"]
				});
				cctv_data.forEach(function(element){
					element.data.features = element.data.features.map(el => ({
						geometry: {
							type: el.geometry.type,
							coordinates: [
								Number(el.geometry.coordinates[0]),
								Number(el.geometry.coordinates[1])
							]
						},
						properties: el.properties,
						type: el.type,
					}))
					console.log(element.data);
					var buffered = turf.buffer(element.data, cctv_distance_setting, {units: 'meters'});
					var ptsWithin = turf.pointsWithinPolygon(raw_data["event"][1], buffered);
					ptsWithin.features.forEach(function(each_point){
						if (event_id_list[each_point] == undefined) {
							event_id_list[each_point] = "has been existed.";
							var input_check = $(
								'<tr class="p-cursor">' +
									'<td>' + condition_area(each_point.properties.TID) + '</td>' +
									'<td>' + condition_disa_level(each_point.properties.DISA_LEVEL) + '</td>' +
									'<td>' + condition_status_type(each_point.properties.STATUS) + '</td>' +
									'<td>' + condition_disa_type(each_point.properties.DISA_TYPE) + '</td>' +
								'</tr>'
							);
							var lat = parseFloat(each_point.geometry.coordinates[1]);
							var lng = parseFloat(each_point.geometry.coordinates[0]);
							input_check.click(function(){
								map.setView([lat, lng], 18);
								backgroud_layer_control("重大災情");
							   });
							   $('#cctv_advise_table tbody').append(input_check);
						}
					});
				});

				$('#cctv_advise_table table').DataTable({
					"order": [[ 1, "desc" ]],
					"searching": true,
					"language": {
						  "emptyTable": "沒有任何重大災害點位鄰近CCTV"
					}
				});
				if ($("#table_10").length == 0) {
					$("#all-cctv-table-div").append(
						'<div>'+
							'<div class="slider-card-head p-2">'+
								'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>警察局CCTV(僅列重大災情交集站位)<i class="fas fa-angle-down float-right mt-1"></i></h5>' +
							'</div>'+
							'<div class="slider-card-content">'+
								'<table class="cctv_control_table mb-2 table table-sm" id="table_10" width="100%" height="100%">' +
									'<thead class="thead-dark">' +
										'<tr>' +
											'<th>站名</th>' +
											'<th>地址</th>' +
										'</tr>' +
									'</thead>' +
									'<tbody>' +
									'</tbody>' +
								'</table>' +
							'</div>' +
						'</div>'
					);
				} else {
					$('#table_10').DataTable().destroy();
					$('#table_10 tbody').empty();
				};
				police_cctv_within.features.forEach(function(each_features){
					var this_properties = each_features.properties;
					var input_check = $(
						'<tr class="p-cursor">' +
							'<td>' + this_properties["id"] + '</td>' +
							'<td>' + this_properties["name"] + '</td>' +
						'</tr>'
					);
					input_check.click(function(){
						map.setView([each_features.geometry.coordinates[1], each_features.geometry.coordinates[0]], 18);
					});
					   $("#table_10 tbody").append(input_check);
				});
				$('#table_10').DataTable({
					"order": [[ 1, "desc" ]],
					"searching": true
				});
			});
		} else {
			toast_open("您尚未選擇任一個EMIS專案，故無法提供CCTV建議查看清單！")
		}
    });
    // $("#cctv_advise_trig").click();
}
